import type { URLString } from "../../types";

/**
 * Default BE base url for local development, this is typically DEV environment url.
 */
const DEFAULT_LOCALHOST_BASE_URL = "http://localhost:8080/";

/**
 * Gets base url for backend. This serves to create urls for API calls. Url is constructed based on <code>window.location</code>, so one FE build can be used for multiple environments.
 * This requires that all environments follow the same pattern.
 *
 * For local development, base url can be overridden by BE_URL variable in .env file. This enables to locally develop FE against any BE.
 * If BE_URL is not specified, then {@link DEFAULT_LOCALHOST_BASE_URL} is used.
 */
export const getBeBaseUrl = (): URLString => {
    /* eslint no-underscore-dangle: 0 */
    if (window.__RUNTIME_CONFIG__?.BE_URL) {
        return window.__RUNTIME_CONFIG__?.BE_URL;
    }
    return window.location.hostname === "localhost"
        ? DEFAULT_LOCALHOST_BASE_URL
        : `${window.location.protocol}//api.${window.location.host}/api/`;
};
